import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardJobComponent } from "./dashboard-job/dashboard-job.component";
import { ChatComponent } from "./chat/chat.component";
import { JobseekerComponentRoutingModule } from "./jobseeker-component-routing.module";
import { RouterModule } from "@angular/router";
import { SettingsComponent } from "./settings/settings.component";
import { VerifyComponent } from "./settings/verify/verify.component";
import { ChangePasswordComponent } from "./settings/change-password/change-password.component";

import { NgOtpInputModule } from "ng-otp-input";  
import { ProfileComponent } from "./profile/profile.component";
import { JobsComponent } from "./jobs/jobs.component";
import { AppliedJobsComponent } from "./jobs/applied-jobs/applied-jobs.component";
import { SavedJobsComponent } from "./jobs/saved-jobs/saved-jobs.component";
import { JobItemComponent } from "./job-item/job-item.component";
import { EmployerListingComponent } from "./employer/employer-listing/employer-listing.component";
import { EmployerDetailComponent } from "./employer/employer-detail/employer-detail.component";
import { SearhFilterComponent } from "./searh-filter/searh-filter.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EditProComponent } from "./profile/edit-pro/edit-pro.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { UserDetailsService } from "../services/user/user-details.service";
import { JobApplyComponent } from "./job-apply/job-apply.component";
import { CongratulationsComponent } from "./congratulations/congratulations.component";
import { AppliedJobsDetailComponent } from "./jobs/applied-jobs/applied-jobs-detail/applied-jobs-detail.component";
// import { SavedJobsDetailComponent } from "./jobs/saved-jobs/saved-jobs-detail/saved-jobs-detail.component";
import { AboutComponent } from "./employer/employer-detail/about/about.component";
import { AppliedSavedJobsItemComponent } from "./common/applied-saved-jobs-item/applied-saved-jobs-item.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { DetailsJobItemComponent } from "./common/details-job-item/details-job-item.component";
import { NotificationComponent } from "./notification/notification.component";
import { EmployerJobsComponent } from "./employer/employer-detail/jobs/jobs.component";
import { DateAgoConvertorPipe } from "../pipe/date-ago-convertor.pipe";

import { DatePipe } from "@angular/common";
import { TimeAgoPipe } from "../pipe/day-ago-pipe";
import { CommonSeeallComponent } from "./common-seeall/common-seeall.component";
import { AccordionModule, AccordionConfig } from "ngx-bootstrap/accordion";
import { LastStepperService } from "../services/last-stepper/last-stepper.service";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";

import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { JobRolesComponent } from "./job-roles/job-roles.component";
import { JobDetailComponent } from "./job-roles/job-detail/job-detail.component";
// import { MessageGroupbyPipe } from "../pipe/messages/message-groupby.pipe";
import { ChatFilterPipe } from "../pipe/messages/chat-filter.pipe";
import { DeleteAccountPasswordComponent } from "./settings/delete-account-password/delete-account-password.component";
import { ViewMyreportComponent } from "./view-myreport/view-myreport.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { SearchAppliedSaveJobsListComponent } from "./common/search-applied-save-jobs-list/search-applied-save-jobs-list.component";
import { ShareModule } from "../shared/shared.module";
import { NgxPaginationModule } from "ngx-pagination";
import { CommonUploadComponent } from "./common-upload/common-upload.component";
import { ImageCropperModule } from "ngx-image-cropper"; 
import { NgxSliderModule } from "@angular-slider/ngx-slider";
@NgModule({
  declarations: [
    DashboardJobComponent,
    ChatComponent,
    CommonUploadComponent,
    SettingsComponent,
    VerifyComponent,
    ChangePasswordComponent, 
    ProfileComponent,
    JobsComponent,
    AppliedJobsComponent,
    SavedJobsComponent,
    JobItemComponent,
    EmployerListingComponent,
    EmployerDetailComponent,
    SearhFilterComponent,
    EditProComponent,
    JobApplyComponent,
    CongratulationsComponent,
    AppliedJobsDetailComponent,
    // SavedJobsDetailComponent,
    AboutComponent,
    EmployerJobsComponent,
    AppliedSavedJobsItemComponent,
    NotificationComponent,
    TimeAgoPipe,
    DateAgoConvertorPipe,
    DetailsJobItemComponent,
    CommonSeeallComponent,
    JobRolesComponent,
    JobDetailComponent,
    // MessageGroupbyPipe,
    DeleteAccountPasswordComponent,
    ChatFilterPipe,
    ViewMyreportComponent,
    SearchAppliedSaveJobsListComponent, 
  ],
  imports: [
    FormsModule,
    RouterModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    JobseekerComponentRoutingModule,
    BsDatepickerModule.forRoot(),
    InfiniteScrollModule,
    GooglePlaceModule,
    ShareModule,
    // DateDifference,
    NgbModule,
    NgbNavModule,
    BsDropdownModule.forRoot(),
    InfiniteScrollModule,
    AccordionModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxPaginationModule,
    ImageCropperModule,
    NgxSliderModule
  ],
  providers: [
    UserDetailsService, DatePipe, LastStepperService, { provide: AccordionConfig }
  ]
})
export class JobseekerComponentModule { }
